import React, { Component } from "react";
import { Layout, Radio, Table, Divider, Modal, Form, Input, Pagination, Button, Select, message } from 'antd';

import Header from '../../components/header'
import Left from '../../components/leftAd'

import '../../assets/css/admin.less'
import './check.less'
import {
    reqCategory,
    reqCheckList,
    reqDeleteCheck, reqDeleteCheckQ,
    reqSkillDetail,
    reqUpload
} from "../../api";
import '../../api/index';

const { Content } = Layout;
const { Option } = Select;
const { TextArea } = Input;

/**
 * 综合考核路由组件
 */
class Check extends Component {

    state = {
        total: 0,
        page: 1,
        size: 10,
        question: '',
        checkList: [],
        selectValue: '',
        ModalText: '',
        visible: false,
        category: [],
        name: '',
        imgId: '',
        QList: [],
        questionAuto: [{ answer: "", question: "" }],
        cases: {},
        deleteVisible: false,
        deleteId: '',
        deleteName: '',
        deleteType: '',
        checkingId: '',
        selectedRowKeys: [],
        check: {}
    };

    getCheckList = async (data) => {
        const result = await reqCheckList(data);
        // console.log(result.data.rows);
        if (result.code === '000000') {
            this.setState({
                checkList: result.data.rows,
                total: result.data.total,
                page: result.data.page
            });
            if (result.data.total > 0) {
                let checkList = this.state.checkList;
                for (let i = 0; i < result.data.rows.length; i++) {
                    const questions = this.state.checkList[i].questions;
                    checkList[i]["title"] = questions[0].question;
                }
                let kid = sessionStorage.getItem("kid");
                let check = "";
                if (kid && kid !== "") {
                    this.getQList(kid);
                    let index = sessionStorage.getItem("kIndex") - 0;
                    check = this.state.checkList[index];
                } else {
                    this.getQList(result.data.rows[0].id);
                    check = result.data.rows[0];
                }
                this.setState({
                    check: check
                });
            }
        } else {
            message.error(result.msg);
        }
    };

    imgNone = (e) => {
        e.persist();
        const img = e.target;
        img.style.display = 'none';
    };

    handleUpload = async (e) => {
        e.persist();
        let file = e.target.files[0];   //选择的图片文件
        let data = new FormData();
        data.append('file', file);

        const result = await reqUpload(data);
        if (result.code === '000000') {
            document.getElementsByClassName("upload")[0].style.display = 'block';
            this.setState({
                imgId: result.data
            });
            message.success("上传成功");
        } else {
            message.error(result.data.msg);
        }

    };

    getCategoryList = async (type) => {
        const result = await reqCategory(type);
        if (result.code === '000000') {
            this.setState({
                category: result.data.rows
            })
        } else {
            message.error(result.msg);
        }
    };

    getQList = async (id) => {
        const result = await reqSkillDetail(id);
        if (result.code === '000000') {
            this.setState({
                QList: result.data.questions,
                checkingId: id
            })
        }
    };

    searchList = async () => {
        const name = document.getElementById("search_input").value;
        let data = {
            page: 1,
            size: 10,
            containsOptions: true,
        };
        if (this.state.selectValue !== '' && this.state.selectValue !== 0) {
            data["type"] = this.state.selectValue;
        }
        if (name && name !== '') {
            data["question"] = name;
            this.setState({
                question: name
            })
        }
        this.getCheckList(data);
    };

    pageClick = async page => {
        const name = document.getElementById("search_input").value;
        sessionStorage.clear();
        let data = {
            page: page,
            size: 10,
            containsOptions: true,
        };
        if (this.state.selectValue !== '' && this.state.selectValue !== 0) {
            data["type"] = this.state.selectValue;
        }
        if (name !== '') {
            data["question"] = name;
        }
        this.getCheckList(data);
    };

    handleCancel = () => {
        this.setState({
            visible: false,
            deleteVisible: false,
            deleteId: '',
            deleteName: '',
            selectedRowKeys: [],
            imgId: ''
        });
    };

    showDeleteModal = (record, type) => {
        if (type === '删除') {
            this.setState({
                deleteId: record.id,
                deleteName: record.id,
                deleteVisible: true,
                deleteType: type
            })
        } else if (type === '批量删除') {
            if (this.state.deleteId === '') {
                message.info("没有选中行");
            } else {
                this.setState({
                    deleteVisible: true,
                    deleteType: type
                })
            }
        } else {
            this.setState({
                deleteId: record.id,
                deleteName: record.question,
                deleteVisible: true,
                deleteType: type,
            })
        }
    };

    deleteCheck = async (ids, e) => {
        e.persist();
        let result = "";
        if (this.state.deleteType === '删除问题') {
            result = await reqDeleteCheckQ(this.state.checkingId, ids);
        } else {
            result = await reqDeleteCheck(ids);
        }
        let data = {};
        if (result.code === '000000') {
            message.success("作废成功");
            data = {
                page: 1,
                size: 10,
                containsOptions:true
            };
            if (this.state.selectValue !== '' && this.state.selectValue !== 0) {
                data["type"] = this.state.selectValue;
            }
            this.getCheckList(data);
            this.handleCancel();
        }
    };

    itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <a>上一页</a>;
        }
        if (type === 'next') {
            return <a>下一页</a>;
        }
        return originalElement;
    };

    showTotal = (total) => {
        return '共' + total + '条记录/每页' + this.state.size + '条';
    };

    selectChange = e => {
        this.setState({
            selectValue: e
        })
    };

    EditCheck = (record, type) => {
        if (type === 'new') {
            sessionStorage.setItem("checkId", "none");
        } else {
            sessionStorage.setItem("checkId", record.id);
        }
        this.props.history.push("/edit");
    };

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return state;
        }
    }

    clearSearch = async () => {
        sessionStorage.clear();
        window.location.reload();
    };

    componentDidMount = async () => {
        this.getCategoryList("CASE");
        this.getCheckList({
            page: 1,
            size: 10,
            containsOptions: true,
        });
        // console.log();
        document.getElementsByClassName("ant-menu-item")[3].click();
        sessionStorage.clear();
        document.getElementsByClassName("ant-menu-item")[4].style.setProperty("display", "block");
        document.getElementsByClassName("ant-menu-item")[4].style.setProperty("color", "#12c4ed");
        document.getElementsByClassName("ant-menu-item")[5].style.setProperty("display", "block");
    };

    render() {

        const { getFieldDecorator } = this.props.form;
        const self = this;
        const { selectedRowKeys, total, page, checkList, ModalText, visible, category, questionAuto, cases, deleteVisible, deleteId } = this.state;

        const columns = [
            {
                title: '编号',
                dataIndex: 'id',
                key: 'id',
                render: (text, record, index) => (
                    <span>{(this.state.page - 1) * this.state.size + index + 1}</span>
                ),
            },
            {
                title: '试题分类',
                dataIndex: 'categoryName',
                key: 'categoryName'
            },
            {
                title: '题干',
                dataIndex: 'title',
                key: 'title'
            },
            {
                title: '选项',
                dataIndex: 'optionValue',
                key: 'optionValue',
                render: (text, record, index) => (
                    // console.log(record.options),
                    <span>{record.options.map((item, index) => (<span>{item.optionKey}.{item.optionValue}&nbsp;&nbsp;&nbsp;</span>))}</span>
                ),
                onCell: () => {
                    return {
                        style: {
                            maxWidth: 550,
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            cursor: 'pointer'
                        }
                    }
                },
            },
            {
                title: '题型',
                dataIndex: 'type',
                key: 'type',
                render: (text, record) => (
                    <span>{record.type}型题</span>
                )
            },
            {
                title: '操作',
                key: 'action',
                render: (text, record) => (
                    <span>
                        <a onClick={this.EditCheck.bind(this, record)}>编辑</a>
                        <Divider type="vertical" />
                        <a onClick={this.showDeleteModal.bind(this, record, '删除')}>作废</a>
                    </span>
                ),
            }
        ];

        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({
                    deleteId: selectedRowKeys.toString(),
                    deleteName: selectedRowKeys.toString(),
                    selectedRowKeys: selectedRowKeys
                })
            },
            getCheckboxProps: record => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
                name: record.name,
            }),
        };

        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <Left>Left</Left>
                    <Content>
                        <div className='table_right check'>
                            <div className='table_search'>
                                <Button className='batch_delete' onClick={this.showDeleteModal.bind(this, deleteId, '批量删除')}>批量作废</Button>
                                <Button className='add_class' onClick={this.EditCheck.bind(this, {}, 'new')}>新建试题</Button>
                                <Button className='batch_delete clear' onClick={this.clearSearch.bind(this)}>重置</Button>
                                <Button className='batch_delete search' onClick={this.searchList.bind(this)}>检索</Button>
                                <div className='search_box'>
                                    <label>类型：</label>
                                    <Select id='grade_select' style={{ width: 165 }}
                                        onChange={this.selectChange.bind(this)}>
                                        <Option key={0} value=''>全部</Option>
                                        <Option key={1} value='A'>A型题</Option>
                                        <Option key={2} value='B'>B型题</Option>
                                        <Option key={2} value='X'>X型题</Option>
                                    </Select>
                                </div>
                                <div className='search_box'>
                                    <label>题干关键字</label>
                                    <Input id='search_input' style={{ width: 160 }} className="search_name" />
                                </div>
                            </div>
                            <Table rowSelection={rowSelection} columns={columns} pagination={false}
                                dataSource={checkList} rowKey={checkList => checkList.id} />
                            <Pagination total={total} current={page} onChange={this.pageClick} itemRender={this.itemRender} showTotal={this.showTotal} />
                        </div>
                        <Modal className='check_modal' title={ModalText} visible={visible} onCancel={this.handleCancel}
                            footer={null} destroyOnClose='true'>
                            <Form onSubmit={this.addCheck}>
                                <Form.Item hidden>
                                    {getFieldDecorator('id', {
                                        initialValue: cases.id,
                                    })(<Input hidden />)}
                                </Form.Item>
                                <Form.Item label="分类">
                                    {getFieldDecorator('categoryId', {
                                        initialValue: 1
                                    })(
                                        <Select>
                                            {
                                                category && category.map((item, index) => (
                                                    <Option key={index} value={item.id}>{item.name}</Option>
                                                ))
                                            }
                                        </Select>
                                    )}
                                </Form.Item>
                                <Form.Item label="答案类型">
                                    {getFieldDecorator('questionType', {
                                        initialValue: cases.type
                                    })(
                                        <Radio.Group>
                                            <Radio value={'A'}>A型</Radio>
                                            <Radio value={'B'}>B型</Radio>
                                            <Radio value={'X'}>X型</Radio>
                                        </Radio.Group>
                                    )}
                                </Form.Item>
                                <Form.Item label="选项">
                                    {getFieldDecorator('options', {
                                        initialValue: cases.options,
                                        rules: [{ required: true, message: '请输入选项!' }],
                                    })(<TextArea rows={4} placeholder={'请输入选项，一行一个选项'} />)}
                                </Form.Item>
                                <Form.Item label="封面">
                                    <Input name="file" accept="image/*" id="upload" type="file"
                                        onChange={this.handleUpload.bind(this)} />
                                </Form.Item>
                                <Form.Item label="预览图">
                                    <img onError={this.imgNone.bind(this)} className='upload'
                                        src={this.state.imgId && global.constant.uploadImage + this.state.imgId} />
                                </Form.Item>
                                <Form.Item>
                                    <div className='auto'>
                                        {
                                            questionAuto && questionAuto.map((item, index) => (
                                                <span key={index}>
                                                    <Form.Item hidden>
                                                        {getFieldDecorator('id' + index, {
                                                            initialValue: item.id,
                                                        })(<Input hidden />)}
                                                    </Form.Item>
                                                    <Form.Item>
                                                        {getFieldDecorator('question' + index, {
                                                            initialValue: item.question,
                                                            rules: [{ required: true, message: '请输入问题!' }],
                                                        })(<Input placeholder="请输入问题" />)}
                                                    </Form.Item>
                                                    <Form.Item>
                                                        {getFieldDecorator('answer' + index, {
                                                            initialValue: item.answer,
                                                            rules: [{ required: true, message: '请输入答案!' }],
                                                        })(<Input placeholder='如:A（多选请用|分开，如A|C）' />)}
                                                    </Form.Item>
                                                    {index < 2 && <Button shape="circle" size="small" icon="plus" type="primary" onClick={() => self.onLinkWay(index, 'add')} />}
                                                    {index > 0 && <Button shape="circle" size="small" icon="minus" type="default" onClick={() => self.onLinkWay(index, 'minus')} />}
                                                </span>
                                            ))
                                        }
                                    </div>
                                </Form.Item>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit">
                                        提交
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Modal>
                        <Modal
                            title="提示"
                            visible={deleteVisible}
                            okText={"确定"}
                            cancelText={"取消"}
                            onOk={this.deleteCheck.bind(this, deleteId)}
                            onCancel={this.handleCancel}>
                            <div>确定作废吗？</div>
                        </Modal>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}

const WrapCheck = Form.create()(Check);
export default WrapCheck;